import { forwardRef } from 'react';

import { HeaderIconSize } from './common/common-header-icon.types';
import { HeaderIconDefaultSize, HeaderIconProps } from './common';
import { ModalHeaderIcon } from './modal-header-icon';

export const HeaderIcon = forwardRef<HTMLDivElement, HeaderIconProps>(
  ({ isFullScreenModalIcon = false, size, ...rest }, ref) => {
    const resolvedSize = size ?? HeaderIconDefaultSize;

    if (isFullScreenModalIcon) {
      return <ModalHeaderIcon {...rest} size={HeaderIconSize.Size40} ref={ref} />;
    }

    return <ModalHeaderIcon {...rest} size={resolvedSize} ref={ref} />;
  },
);
